import { PromiseCancellationException } from "@ostack.tech/kform";

/**
 * Function that re-throws the provided {@link caughtError} argument, unless it
 * is an instance of {@link PromiseCancellationException}.
 *
 * This is useful in scenarios where cancellations are expected and, as such,
 * shouldn't be regarded as errors.
 *
 * @param caughtError Caught error.
 * @throws {caughtError} When not an instance of
 *   {@link PromiseCancellationException}.
 */
export function ignorePromiseCancellationException(caughtError: unknown) {
  if (!(caughtError instanceof PromiseCancellationException)) {
    throw caughtError;
  }
}
